import { codeSplit } from 'bernie-core';

export const CodeSplitContentMap = codeSplit(
  () => import(/* webpackChunkName: "cp-cmslite-content" */ '../content-v7') as any
);
